import { Skeleton, Stack } from '@omnipresentgroup/design-system';
import { useLegalEntity } from '@omnipresentgroup/domains';

export const LegalEntityName = ({
  legalEntityId,
}: {
  legalEntityId?: string;
}) => {
  const { data: legalEntity, isLoading } = useLegalEntity({
    id: legalEntityId || '',
  });

  return isLoading ? (
    <Stack h={24} justify="center">
      <Skeleton />
    </Stack>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    legalEntity?.name || '-'
  );
};
